import { Spinner } from "@dms/ui";
import { Navigate, Outlet, useLocation } from "react-router-dom";

import { ForbiddenPage } from "../pages/ForbiddenPage";
import { useAuth } from "./AuthContext";

function FullScreenLoader() {
  return (
    <div
      style={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "100vh" }}
      role="status"
      aria-label="Завантаження"
    >
      <Spinner size={32} />
    </div>
  );
}

/**
 * Auth-aware guard (12-screen-spec §14): неавтентифікований → /login?returnTo=;
 * з `requiredRoles` — без потрібної ролі показуємо Forbidden (403);
 * тимчасовий пароль (16-security §4.1) → лише екран зміни пароля.
 */
export function ProtectedRoute({ requiredRoles }: { requiredRoles?: string[] }) {
  const { status, user } = useAuth();
  const location = useLocation();

  if (status === "loading") {
    return <FullScreenLoader />;
  }
  if (status === "unauthenticated") {
    const returnTo = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?returnTo=${returnTo}`} replace />;
  }
  if (user?.must_change_password && location.pathname !== "/admin/change-password") {
    return <Navigate to="/admin/change-password" replace />;
  }
  if (
    requiredRoles &&
    requiredRoles.length > 0 &&
    !requiredRoles.some((role) => user?.roles.includes(role))
  ) {
    return <ForbiddenPage />;
  }
  return <Outlet />;
}
